import { render, staticRenderFns } from "./AdminBaseReviewApplications.vue?vue&type=template&id=489f26bf"
import script from "./AdminBaseReviewApplications.vue?vue&type=script&lang=js"
export * from "./AdminBaseReviewApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports